import { connect } from 'react-redux';
import Syarat from '../../../views/Kurikulum/Analisa/Syarat.kurikulum.view.js';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(Syarat);
